/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';

import Skeleton from '@mui/material/Skeleton';

const TableLoaderSmall = () => (
  <>
    <Skeleton animation="pulse" height={50} sx={{ marginBottom: '1rem' }} />
    <table className="table table-striped table-hover dataTable">
      <thead>
        <tr>
          <th style={{ width: '30px' }}>
            <Skeleton />
          </th>
          <th style={{ width: '40px' }}>
            <Skeleton />
          </th>
          <th style={{ width: '50px' }}>
            <Skeleton />
          </th>
          <th style={{ width: '40px' }}>
            <Skeleton />
          </th>
          <th>
            <Skeleton />
          </th>
          <th>
            <Skeleton />
          </th>
        </tr>
      </thead>
      <tbody>
        <tr style={{ height: '56px' }}>
          <td><Skeleton animation="wave" /></td>
          <td><Skeleton animation="wave" /></td>
          <td><Skeleton animation="wave" /></td>
          <td><Skeleton animation="wave" /></td>
          <td><Skeleton animation="wave" /></td>
          <td><Skeleton animation="wave" /></td>
        </tr>
        <tr style={{ height: '56px' }}>
          <td><Skeleton animation="wave" /></td>
          <td><Skeleton animation="wave" /></td>
          <td><Skeleton animation="wave" /></td>
          <td><Skeleton animation="wave" /></td>
          <td><Skeleton animation="wave" /></td>
          <td><Skeleton animation="wave" /></td>
        </tr>
        <tr style={{ height: '56px' }}>
          <td><Skeleton animation="wave" /></td>
          <td><Skeleton animation="wave" /></td>
          <td><Skeleton animation="wave" /></td>
          <td><Skeleton animation="wave" /></td>
          <td><Skeleton animation="wave" /></td>
          <td><Skeleton animation="wave" /></td>
        </tr>
        <tr style={{ height: '56px' }}>
          <td><Skeleton animation="wave" /></td>
          <td><Skeleton animation="wave" /></td>
          <td><Skeleton animation="wave" /></td>
          <td><Skeleton animation="wave" /></td>
          <td><Skeleton animation="wave" /></td>
          <td><Skeleton animation="wave" /></td>
        </tr>
        <tr style={{ height: '56px' }}>
          <td><Skeleton animation="wave" /></td>
          <td><Skeleton animation="wave" /></td>
          <td><Skeleton animation="wave" /></td>
          <td><Skeleton animation="wave" /></td>
          <td><Skeleton animation="wave" /></td>
          <td><Skeleton animation="wave" /></td>
        </tr>
      </tbody>
    </table>
    <div className="row">
      <div className="col-lg-8">
        <Skeleton animation="pulse" height={50} sx={{ marginBottom: '1rem' }} />
      </div>
      <div className="col-lg-4 text-right">
        <Skeleton height={50} width={30} sx={{ display: 'inline-block', marginRight: '1rem' }} />
        <Skeleton height={50} width={30} sx={{ display: 'inline-block', marginRight: '1rem' }} />
        <Skeleton height={50} width={30} sx={{ display: 'inline-block' }} />
      </div>
    </div>
  </>
);

export default TableLoaderSmall;
